// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type { BodyUploadModuleVersionImage, GenericApiResponse, HTTPValidationError } from '../../models';

/**
 * Upload an image for the given module version. PNGs are converted to JPEG silently.
 * @summary Upload Module Version Image
 */
export const uploadModuleVersionImage = (
  moduleId: string,
  version: string,
  bodyUploadModuleVersionImage: BodyUploadModuleVersionImage,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  const formData = new FormData();
  formData.append('file', bodyUploadModuleVersionImage.file);

  return axios.post(`/modules/${moduleId}/versions/${version}/image`, formData, options);
};

export const getUploadModuleVersionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadModuleVersionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: BodyUploadModuleVersionImage },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadModuleVersionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadModuleVersionImage>>,
    { moduleId: string; version: string; data: BodyUploadModuleVersionImage }
  > = (props) => {
    const { moduleId, version, data } = props ?? {};

    return uploadModuleVersionImage(moduleId, version, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: BodyUploadModuleVersionImage },
    TContext
  >;
};

export type UploadModuleVersionImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadModuleVersionImage>>>;
export type UploadModuleVersionImageMutationBody = BodyUploadModuleVersionImage;
export type UploadModuleVersionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Upload Module Version Image
 */
export const useUploadModuleVersionImage = <
  TData = Awaited<ReturnType<typeof uploadModuleVersionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: BodyUploadModuleVersionImage },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; data: BodyUploadModuleVersionImage },
  TContext
> => {
  const mutationOptions = getUploadModuleVersionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete image for module
 * @summary Delete Module Version Image
 */
export const deleteModuleVersionImage = (
  moduleId: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.delete(`/modules/${moduleId}/versions/${version}/image`, options);
};

export const getDeleteModuleVersionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteModuleVersionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteModuleVersionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModuleVersionImage>>,
    { moduleId: string; version: string }
  > = (props) => {
    const { moduleId, version } = props ?? {};

    return deleteModuleVersionImage(moduleId, version, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string },
    TContext
  >;
};

export type DeleteModuleVersionImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModuleVersionImage>>>;

export type DeleteModuleVersionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Module Version Image
 */
export const useDeleteModuleVersionImage = <
  TData = Awaited<ReturnType<typeof deleteModuleVersionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string }, TContext> => {
  const mutationOptions = getDeleteModuleVersionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Automatically generate a cover image for the module using GPT-Image.
 * @summary Generate Module Version Image
 */
export const generateModuleVersionImage = (
  moduleId: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/modules/${moduleId}/versions/${version}/generate-image`, undefined, options);
};

export const getGenerateModuleVersionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof generateModuleVersionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['generateModuleVersionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateModuleVersionImage>>,
    { moduleId: string; version: string }
  > = (props) => {
    const { moduleId, version } = props ?? {};

    return generateModuleVersionImage(moduleId, version, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string },
    TContext
  >;
};

export type GenerateModuleVersionImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateModuleVersionImage>>
>;

export type GenerateModuleVersionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Generate Module Version Image
 */
export const useGenerateModuleVersionImage = <
  TData = Awaited<ReturnType<typeof generateModuleVersionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string }, TContext> => {
  const mutationOptions = getGenerateModuleVersionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
